import { Box, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BackButton = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <Box
            onClick={() => navigate(-1)}
            sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                mb: 2,
                ml: -1,
                color: "white",
                "&:hover": { opacity: 0.8 }
            }}
        >
            <ChevronLeftIcon />
            <Typography variant="body1">{t("common.back")}</Typography>
        </Box>
    );
};

export default BackButton;
